import { Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'

interface EmarSecondSignatureFieldProps {
  confirmProps: Record<string, any>
  fields: Record<string, any>
  formId: string
  formState: Record<string, any>
  onConfirm: () => void
  requireConfirm: boolean
  testId?: string
}

/**
 * @description Renders EmarSecondSignatureField for the Add Medication modal
 * @param {EmarSecondSignatureFieldProps} props - The component's props.
 * @returns {JSX.Element} EmarSecondSignatureField.
 */
export default function EmarSecondSignatureField(
  props: EmarSecondSignatureFieldProps
): JSX.Element {
  const {
    confirmProps,
    fields,
    formId,
    formState,
    onConfirm,
    requireConfirm,
    testId
  } = props

  const title = 'Requires second signature?'

  const renderCDNote = () => {
    return (
      <div
        data-testid={
          testId ? `${testId}-second-signature-note` : 'second-signature-note'
        }
      >
        <div
          style={styles.labelNote}
          data-testid={
            testId
              ? `${testId}-second-signature-label-note`
              : 'second-signature-label-note'
          }
        >
          You will need to 'Add a witness' for these medications.
        </div>
        <div
          style={styles.cdNoteContainer}
          data-testid={
            testId ? `${testId}-controlled-drug-note` : 'controlled-drug-note'
          }
        >
          {fields.control &&
            (formState.controlledDrugInitial
              ? `Is a controlled drug (${fields.control})`
              : `Is not a controlled drug (${fields.control})`)}
          {/* <HelpLink
            displayText={false}
            style={styles.cdNoteHelpIcon}
          /> */}
        </div>
      </div>
    )
  }

  const selectedOptionFieldStyle = requireConfirm ? styles.prepopField : null

  return (
    <div
      style={styles.userGeneratedFieldContainer}
      data-testid={
        testId ? `${testId}-second-signature-field` : 'second-signature-field'
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        {/* @ts-ignore */}
        <Field
          compact
          confirmProps={confirmProps}
          displayLabel
          fieldType="radios"
          formId={formId}
          hasComment
          keys="secondSignatureRequired"
          label={title}
          layout="no-label"
          selectedOptionFieldStyle={selectedOptionFieldStyle}
          options={DEFAULT_RADIO_OPTIONS}
          onConfirm={onConfirm}
          renderLabelChildren={renderCDNote}
          requireConfirm={requireConfirm}
          required
          type="userGeneratedFieldLayout"
          values={fields}
          data-testid={
            testId
              ? `${testId}-second-signature-field-input`
              : 'second-signature-field-input'
          }
        />
      </Suspense>
    </div>
  )
}

const DEFAULT_RADIO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
]

const styles = {
  cdNoteContainer: {
    display: 'flex',
    marginTop: 16
  },
  cdNoteHelpIcon: {
    marginLeft: 6
  },
  labelNote: {
    color: colors.darkgrey,
    fontSize: 12
  },
  prepopField: {
    background: colors.hoverblue
  },
  userGeneratedFieldContainer: {
    marginBottom: 16
  }
}
